export default {
  SET_BRANDS (state, brands) {
    state.brands = brands
  },
  REMOVE_RECORD (state, itemId) {
    const roleIndex = state.brands.findIndex((u) => u.id === itemId)
    state.brands.splice(roleIndex, 1)
  }
}
